import 'components/catalog.tag'
riot.tag2('labels-list', '  <catalog object="ProductLabel" cols="{cols}" search="true" reorder="true" handlers="{handlers}" reload="true" store="products-labels-list" allselect="true" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(edit, &quot;products&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="imageUrlPreview"><img riot-src="{row.imageUrlPreview}" alt="" width="32" height="32"></datatable-cell>\n      <datatable-cell name="code">{row.code}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'ProductLabel';

self.cols = [{ name: 'id', value: '#' }, { name: 'imageUrlPreview', value: 'Иконка' }, { name: 'code', value: 'Код' }, { name: 'name', value: 'Наименование' }];

self.add = function () {
    return riot.route('/products/labels/new');
};

self.edit = function (e) {
    return riot.route('products/labels/' + e.item.row.id);
};

observable.on('products-labels-reload', function () {
    return self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/products/labels/labels-list.tag